export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()

    const initiateAffirm = async () => {
		
		if (window.affirm !== undefined) {
			return;
		}

		const _affirm_config = {
			public_api_key: runtimeConfig.public.affirmKey,
			script: runtimeConfig.public.affirmUrl,
		};

		(function (l, g, m, e, a, f, b) {
		var d, c = l[m] || {},
			h = document.createElement(f),
			n = document.getElementsByTagName(f)[0],
			k = function (a, b, c) { return function () { a[b]._.push([c, arguments]) } };
		c[e] = k(c, e, "set");
		d = c[e];
		c[a] = {};
		c[a]._ = [];
		d._ = [];
		c[a][b] = k(c, a, b);
		a = 0;
		for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++) d[b[a]] = k(c, e, b[a]);
		a = 0;
		for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function () { };
		h.async = true;
		h.src = g[f];
		n.parentNode.insertBefore(h, n);
		delete g[f];
		d(g);
		l[m] = c;
		})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
	}

    const initiateTawkWidget = async () => {
		
		const tawk_url = 'https://embed.tawk.to/5ea2ea2369e9320caac6f331/default';

        const {proxy, onLoaded } = useScript({
            src:tawk_url,
            crossorigin: '*',
            charset: 'UTF-8',
            clientInit:import.meta.server
                ? undefined
                : () => {
                    window.Tawk_API = window.Tawk_API || {};
                    window.Tawk_LoadStart = new Date();
                }
            },
        )

        const sendUserDetailsToApi = (data) => {
			const userData = data;

			$fetch(useCountryPath('/tawkchat'), 
				{
					method:'POST',
					body: userData,
				}
			)	
			.then(response => {
				// Handle response if needed
				console.log('User details sent to API successfully:', response);
			})
			.catch(error => {
				console.error('Error sending user details to API:', error);
			});
		};
      
        onLoaded(() => {
            
            window.Tawk_API.onOfflineSubmit = function (data) {
            	sendUserDetailsToApi(data);
            };

            window.Tawk_API.onPrechatSubmit = function (data) {
            	sendUserDetailsToApi(data);
            };
        })

	}

    const initiateHotJar = async () => {
        
        const { proxy } = useScriptHotjar({
           id: 4946101,
        })

    }

	nuxtApp.hook('app:mounted', () => {
		
        const { user, isAuthenticated } = useSanctumAuth();
		initiateAffirm().catch(console.error);
		
        // initiateTrustPilot().catch(console.error);

		if (nuxtApp.$country.location === 'US') {
			// setTimeout(() => initiateTawkWidget().catch(console.error));

            initiateTawkWidget().catch(console.error)
		}
        
         
		if(isAuthenticated.value){
			const emailIds = ['poddardiamonds', 'friendlydiamonds', 'etmedialabs']
			const containsKeyword = emailIds.some(email => user.value.email.includes(email));
			if(containsKeyword){
				return
			}
		}
		if(runtimeConfig.public.enviroment == 'production'){
            initiateHotJar().catch(console.error);
			// setTimeout(() => initiateHotjar().catch(console.error), 1000);
		}
	});


	
});
